import styled from 'styled-components';

export const AddSection = styled.div`
  margin-bottom: 45px;
  
  @media(min-width: 1024px) {
    width: 50%;
  }
`;

export const AddDescription = styled.p`
  margin: 0;
  padding: 0;
  
  font-size: 10px;
  line-height: 14px;
  
  @media(min-width: 768px) {
    font-size: 12px;
    line-height: 16px;
  }
`;

export const AddInputItem = styled.div`
  width: 100%;
  margin-bottom: 15px;
  
  &:not(:last-child) {
    margin-bottom: 25px;
  }
  
  @media(min-width: 1024px) {
    margin-bottom: 0;
  }
  
  p {
    margin: 0;
    margin-bottom: 5px;
    padding: 0;
    
    font-size: 14px;
    line-height: 1;
    
    & + div {
      border-radius: 6px;
    }
  }
`;

export const AddInputButtonContainer = styled.div`
  margin-top: 30px;
  
  button {
    padding-left: 30px;
    padding-right: 30px;
  }
`;

export const Message = styled.p`
  margin: 0;
  margin-bottom: 20px;
  padding: 0;
  
  font-size: 14px;
  color: ${({ theme }) => theme.red};
`;
